import Vue from 'vue';
import Vuex from 'vuex';
import {
    setCookie,
    setStore,
    getStore,
    removeStore,
    modifyJson
} from '@/config/mUtils'
import {
    authority
} from "@/config/authority";
Vue.use(Vuex)
//全局变量
const state = {
    //页面加载时
    pageLoading: false,
    //数据加载时
    dataLoading: false,
    //当前页面路径
    routerUrl: '',
    //用户信息
    userInfo: {},
    //页面数据储存
    pageData: {},
    newdata: [],
    badge: 0,  //用户反馈未处理数量
    refreshList: [],  //刷新的页面
    keepAliveRoute: ["orderManage"],  //缓存的页面
    companyUserId: "",
    orderRefresh: false, //订单页面是否刷新
    orderRemainingNumber: 0, //用户剩余发单次数
    companyUserName: '',
    companyUserPortrait: "",
}
//缓存浏览器的数据名称
const cacheNameList = ["userInfo", "pageData", "newdata"];
var copyState = deepCopy(state);  //拷贝state对象
//数据处理
const mutations = { //触发状态
    // 还原state数据
    setCompanyUserId (state, payload) {

        state.companyUserId = payload;
        setCookie("U_id", payload, 30);

    },
    setCompanyUserName (state, payload) {
        if (payload) {
            state.companyUserName = payload;
            setCookie("U_name", payload, 30);
        }
    },
    setCompanyUserPortrait (state, payload) {
        if (payload) {
            state.companyUserPortrait = payload;
            setCookie("U_portrait", payload, 30);
        }
    },
    mResState (state) {
        for (var i in copyState) {
            state[i] = copyState[i]  // 递归赋值
        }
    },
    //取出缓存数据
    setCacheData (state) {
        for (var item of cacheNameList) {
            let getData = sessionStorage.getItem(item);
            if (getData) {
                state[item] = JSON.parse(getData);
            }
        }
    },
    // 修该badge
    setBadge (state, payload) {
        state.badge = payload;
    },
    //页面加载时
    setPageLoading (state, payload) {
        state.pageLoading = payload;
    },
    //数据加载时
    setDataLoading (state, payload) {
        state.dataLoading = payload;
    },
    //当前页面路径
    setPath (state, payload) {
        state.routerUrl = payload;
    },
    //储存用户信息
    setUserInfo (state, payload) {
        if (payload) {
            state.userInfo = modifyJson(payload, state.userInfo);
            setStore('userInfo', state.userInfo);
            state.newdata = payload.newdata;
            setStore('newdata', state.newdata);
        }
    },
    //页面数据储存
    setPageData (state, payload) {
        if (payload) {
            state.pageData = modifyJson(payload, state.pageData);
            setStore('pageData', state.pageData);
        }
    },
    // 对数字角标操作
    jianBadge: (state) => {
        state.badge -= 1;
    },
    // 添加要刷新的页面
    setRefreshList (state, name) {
        let exists = false;
        state.refreshList.forEach((item, index) => {
            if (name == item) {
                exists = true;
            }
        })
        if (!exists) {
            state.refreshList.push(name);
        }
    },
    // 清空刷新页面列表
    empty (state, arr) {
        state.refreshList = [];
    },
    // 订单页面刷新状态修改
    setOrder (state, orderRefresh) {
        state.orderRefresh = orderRefresh;
    },
    setOrderRemainingNumber (state, orderRemainingNumber) {
        state.orderRemainingNumber = orderRemainingNumber;
    }
}

//异步处理
const actions = {

}
function deepCopy (p, c) {
    var c = c || {};
    for (var i in p) {
        if (typeof p[i] === 'object') {
            c[i] = (p[i].constructor === Array) ? [] : {};
            deepCopy(p[i], c[i]);
        } else {
            c[i] = p[i];
        }
    }
    return c;
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/config/store.js